import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle } from 'lucide-react';

const PaymentCancelled = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 pt-20 flex items-center justify-center p-4">
      <Card className="max-w-md w-full">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4">
            <XCircle className="h-12 w-12 text-yellow-600" />
          </div>
          
          <CardTitle className="text-2xl">Payment Cancelled</CardTitle>
        </CardHeader>
        
        <CardContent className="text-center space-y-4">
          <p className="text-gray-600">
            Your payment was cancelled. No charges have been made to your account.
          </p>
          
          <p className="text-sm text-gray-500">
            If you encountered any issues during the payment process, please don't hesitate to contact our support team.
          </p>
          
          <div className="pt-4 space-y-2">
            <Button 
              onClick={() => navigate('/')} 
              className="w-full bg-purple-600 hover:bg-purple-700"
            >
              Return Home
            </Button>
            
            <Button 
              onClick={() => navigate('/practitioners')} 
              variant="outline" 
              className="w-full"
            >
              Browse Practitioners
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentCancelled;